
import {Component, Emit, Prop, Vue} from "vue-property-decorator";

// #268 リニューアルページ共通ボタン
// to: サイト内遷移(router-link) / href: 外部リンク(別タブ) / どちらも無ければclickイベント
@Component
export default class BrandButton extends Vue {
  @Prop({type: String, required: false, default: ""})
  to!: string;

  @Prop({type: String, required: false, default: ""})
  href!: string;

  @Prop({type: String, required: false, default: "primary"})
  variant!: "primary" | "outline" | "invert" | "ghost";

  @Prop({type: String, required: false, default: ""})
  icon!: string;

  @Emit("click")
  private handleClick() {
    // イベント発火のみ
  }
}
